<template>
  <div>
    <form class="a-filter admin-filter">
      <div class="a-filter__header">
        <h2 v-t="'admin.users'"></h2>
      </div>

      <div class="a-tab__control">
        <router-link :to="{query: { 'user-type': tab.userType }}"
                     tag="a"
                     class="a-tab__btn"
                     exact
                     active-class="a-active"
                     v-for="tab of tabs" :key="tab.label">
          {{$t(tab.label)}}
        </router-link>
      </div>

      <component :is="activeFiltersComponent"></component>
      <component :is="activeResultsComponent"></component>
    </form>
  </div>
</template>

<script>
  import CustomerUsersFilter from './CustomerUsersFilter'
  import CustomerUsersResults from './CustomerUsersResults'
  import ParticipantUsersFilter from './ParticipantUsersFilter'
  import ParticipantUsersResults from './ParticipantUsersResults'

  export default {
    components: {
      CustomerUsersFilter,
      CustomerUsersResults,
      ParticipantUsersFilter,
      ParticipantUsersResults
    },

    watch: {
      '$route.query': {
        immediate: true,
        handler: function(to, from) {
          if (!this.activeTab) {
            this.$router.replace({
              query: {
                'user-type': this.tabs[0].userType
              }
            });
          }
          else if (_.get(to, 'user-type') !== _.get(from, 'user-type')) {
            this.$store.dispatch('clearUsersList');
          }
        }
      }
    },

    computed: {
      tabs() {
        return [
          {
            label: 'form.user-search.user-type.customer',
            userType : 'customer',
            filters: 'CustomerUsersFilter',
            results: 'CustomerUsersResults'
          },

          {
            label: 'form.user-search.user-type.participant',
            userType: 'participant',
            filters: 'ParticipantUsersFilter',
            results: 'ParticipantUsersResults'
          }
        ]
      },

      activeTab() {
        return _.find(this.tabs, { userType: this.$route.query['user-type']});
      },

      activeFiltersComponent() {
        return _.get(this.activeTab, 'filters')
      },

      activeResultsComponent() {
        return _.get(this.activeTab, 'results');
      }
    }
  }
</script>

<style scoped>

</style>
